import {useCallback, useEffect, useState} from "react";
import {fetchAdminSingleType, saveAdminSingleType} from "./content-type-admin-api";

function messageOf(error) {
    return error?.response?.data?.error?.message || error?.message || "content-type-request-error";
}

export function useSingleTypeData(uid) {
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const value = await fetchAdminSingleType(uid);
            setItem(value);
            return value;
        } catch (requestError) {
            setError(messageOf(requestError));
            throw requestError;
        } finally {
            setLoading(false);
        }
    }, [uid]);

    const save = useCallback(async (payload) => {
        setSaving(true);
        setError(null);
        try {
            const value = await saveAdminSingleType(uid, payload);
            setItem(value);
            return value;
        } catch (requestError) {
            setError(messageOf(requestError));
            throw requestError;
        } finally {
            setSaving(false);
        }
    }, [uid]);

    useEffect(() => {
        load().catch(() => undefined);
    }, [load]);

    return {item, loading, saving, error, load, save};
}
